// extracted by mini-css-extract-plugin
export default {"timestamp":"SiteDashboardTimestamp-timestamp-dc338b784a113010c123b9dfecba072e","root":"SiteDashboardTimestamp-root-857f8644017e942979d7f0b6f3f16957"};